module.exports = __webpack_public_path__ + "static/img/hexin.411b8cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/aboutsUs/hexin.png
// module id = Pc/C
// module chunks = 1